module.exports = __webpack_public_path__ + "media/images/bg06-2fe12ea3faa84b988059a8c7bf0685e3.png";